"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.updateEmailResponse = exports.putCustomerIdentityResponse = exports.postCustomerIdentityResponse = exports.getCustomerIdentityResponse = exports.getCanceledCustomerIdentityResponse = exports.getSuspendedCustomerIdentityResponse = exports.getPausedCustomerIdentityResponse = exports.getFAOnboardingCustomerIdentityResponse = exports.getOnboardingCustomerIdentityResponse = exports.getIdentityMatchStatusResponse = void 0;
var identity_1 = require("../identity");
var schema_identity_1 = require("../orchestration/schema-identity");
var activeCustomer = {
    customer_public_id: 'Ww0W6x6pk1g7YFtI3Eh1XCZIy301',
    customer_type: 'normal',
    first_name: 'Mocked',
    last_name: 'User',
    email: 'mocked.user@getflex.com',
    phone: '15555551234',
    address_line1: '1100 27th Ave NW #1100',
    address_line2: '',
    city: 'Minot',
    state: 'ND',
    zip: '58703',
    is_active: true,
    is_blocked: false,
    referral_id: 'b3b37824-a712-4d54-a116-c54de5afbc0d',
    customer_status: identity_1.CustomerStatus.ACTIVE,
    date_email_verified: '2023-03-29T16:01:07.289869-06:00',
    date_joined: '2023-03-29T16:01:07.289869-06:00',
    date_phone_verified: '2023-03-29T16:01:07.289869-06:00',
    date_last_login: '2023-03-30T16:01:07.289869-06:00',
    date_last_updated: '2023-03-30T16:01:07.289869-06:00'
};
var activeAccount = {
    biller_public_id: 'friedman:norria',
    status: identity_1.BillerAccountStatus.ACTIVE,
    unit_nbr: '100',
    biller_account_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
    date_created: '2023-03-19T16:01:07.289869-06:00',
    date_updated: '2023-03-30T16:01:07.289869-06:00'
};
var pendingAccount = {
    biller_public_id: 'friedman:norria',
    status: identity_1.BillerAccountStatus.PENDING,
    unit_nbr: '100',
    biller_account_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
    date_created: '2023-03-19T16:01:07.289869-06:00',
    date_updated: '2023-03-30T16:01:07.289869-06:00'
};
var pausedAccount = {
    biller_public_id: 'friedman:norria',
    status: identity_1.BillerAccountStatus.PAUSED,
    unit_nbr: '100',
    biller_account_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
    date_created: '2023-03-19T16:01:07.289869-06:00',
    date_updated: '2023-03-30T16:01:07.289869-06:00'
};
var newBiller = {
    biller_public_id: 'friedman:norria',
    biller_type: 'direct_integration',
    biller_name: 'North Highlands-Minot, LLC',
    biller_system: 'yardi',
    status: 'active',
    document_id: 'friedman:norria',
    date_created: '2023-03-29T16:01:07.289869-06:00',
    date_updated: '2023-03-30T16:01:07.289869-06:00'
};
exports.getIdentityMatchStatusResponse = {
    biller_account_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
    account_status: identity_1.BillerAccountStatus.PENDING,
    match_status: schema_identity_1.IdentityMatchStatus.MATCHED,
    matched_response: ''
};
exports.getOnboardingCustomerIdentityResponse = {
    onboard_status: schema_identity_1.OnboardStatus.ONBOARDING,
    customer: activeCustomer,
    current_account: {
        account: pendingAccount,
        biller: {
            biller_public_id: 'friedman:norria',
            biller_type: 'direct_integration',
            biller_name: 'North Highlands-Minot, LLC',
            biller_system: 'yardi',
            status: 'validated',
            document_id: 'friedman:norria',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    }
};
exports.getFAOnboardingCustomerIdentityResponse = {
    onboard_status: schema_identity_1.OnboardStatus.ONBOARDING,
    customer: activeCustomer,
    current_account: {
        account: pendingAccount,
        biller: {
            biller_public_id: 'recyyKh2nQxY0iNCA',
            biller_type: 'out_of_network',
            biller_name: 'Out of Network',
            biller_system: 'oon',
            status: 'validated',
            document_id: 'recyyKh2nQxY0iNCA',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    }
};
exports.getPausedCustomerIdentityResponse = {
    onboard_status: schema_identity_1.OnboardStatus.ACTIVE,
    customer: activeCustomer,
    current_account: {
        account: pendingAccount,
        biller: {
            biller_public_id: 'friedman:norria',
            biller_type: 'direct_integration',
            biller_name: 'North Highlands-Minot, LLC',
            biller_system: 'yardi',
            status: 'validated',
            document_id: 'friedman:norria',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    }
};
exports.getSuspendedCustomerIdentityResponse = {
    onboard_status: schema_identity_1.OnboardStatus.ACTIVE,
    customer: activeCustomer,
    current_account: {
        account: pausedAccount,
        biller: {
            biller_public_id: 'friedman:norria',
            biller_type: 'direct_integration',
            biller_name: 'North Highlands-Minot, LLC',
            biller_system: 'yardi',
            status: 'validated',
            document_id: 'friedman:norria',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    }
};
exports.getCanceledCustomerIdentityResponse = {
    onboard_status: schema_identity_1.OnboardStatus.ACTIVE,
    customer: __assign(__assign({}, activeCustomer), { is_active: false, customer_status: identity_1.CustomerStatus.CANCELED }),
    current_account: {
        account: pausedAccount,
        biller: {
            biller_public_id: 'friedman:norria',
            biller_type: 'direct_integration',
            biller_name: 'North Highlands-Minot, LLC',
            biller_system: 'yardi',
            status: 'validated',
            document_id: 'friedman:norria',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    }
};
exports.getCustomerIdentityResponse = {
    onboard_status: schema_identity_1.OnboardStatus.ACTIVE,
    customer: activeCustomer,
    current_account: {
        account: activeAccount,
        biller: {
            biller_public_id: 'friedman:norria',
            biller_type: 'direct_integration',
            biller_name: 'North Highlands-Minot, LLC',
            biller_system: 'yardi',
            status: 'validated',
            document_id: 'friedman:norria',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    },
    active_account: {
        account: activeAccount,
        biller: {
            biller_public_id: 'friedman:norria',
            biller_type: 'direct_integration',
            biller_name: 'North Highlands-Minot, LLC',
            biller_system: 'yardi',
            status: 'validated',
            document_id: 'friedman:norria',
            date_created: '2023-03-29T16:01:07.289869-06:00',
            date_updated: '2023-03-30T16:01:07.289869-06:00'
        }
    }
};
exports.postCustomerIdentityResponse = {
    customer: activeCustomer,
    new_account: pendingAccount,
    new_account_biller: newBiller,
    property_match: {
        matched_from_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
        matched_to_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
        matched_status: schema_identity_1.IdentityMatchStatus.MATCHED,
        biller_public_id: 'friedman:norria',
        unit_nbr: '100',
        matched_response: '',
        date_created: '2023-03-29T16:01:07.289869-06:00',
        date_updated: '2023-03-30T16:01:07.289869-06:00'
    }
};
exports.putCustomerIdentityResponse = {
    customer: activeCustomer,
    new_account: pendingAccount,
    new_account_biller: newBiller,
    property_match: {
        matched_from_public_id: 'd6b542bf-faad-43d6-97fd-ed2781628782',
        matched_to_public_id: 'd5b441bf-faad-43d6-97fd-ed2781628781',
        matched_status: schema_identity_1.IdentityMatchStatus.MATCHED,
        biller_public_id: 'friedman:norria',
        unit_nbr: '100',
        matched_response: '',
        date_created: '2023-03-29T16:01:07.289869-06:00',
        date_updated: '2023-03-30T16:01:07.289869-06:00'
    }
};
exports.updateEmailResponse = {};
